const Categories = () => (
  <p className="under-construction"> Under construction ...</p>
);

export default Categories;
